import { inView, timeline } from "motion";

document.querySelectorAll(".element-impactcenters").forEach((el) => {
  inView(
    el,
    () => {
      timeline([
        [
          el.querySelector(".panel-header h2 span span"),
          {
            opacity: 1,
            transform: "translate3d(0, 0, 0)",
          },
          {
            duration: 0.6,
          },
        ],
        [
          el.querySelectorAll(".panel-header svg path"),
          {
            strokeDashoffset: 0,
          },
          {
            duration: 1.5,
            at: "-25%",
          },
        ],
      ]);
    },
    {
      margin: "0px 0px -25% 0px",
    },
  );
});
